module.exports = __webpack_public_path__ + "img/img-trading-03-1.94058a92.png";